var t=function(t,s){this.activeTargets=[],this.skippedTargets=[],this.observationTargets=[],this.observer=t,this.callback=s};export{t as ResizeObserverDetail};
//# sourceMappingURL=ResizeObserverDetail.js.map
